import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const diabetes: AnswerPathTreeNode = {
  path: 'diabetes',
  children: [
    { path: 'type', nodeId: NodeIds.healthInsuredDiabetesType },
    { path: 'details', nodeId: NodeIds.healthInsuredDiabetesDetails },
  ],
};
